import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import {baseUrl, ipAddress, userLocation, userName} from "../Univ.js";
const PoToGrnEntry = () => {
    const {id} = useParams();
    const [poData, setPoData] = useState({});
    const [rows, setRows] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [invoiceNo, setInvoiceNo] = useState("");
    const [subtotal, setSubtotal] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        if (id) fetchPO();
    }, [id]);
    useEffect(() => {
        let total = 0;
        rows.forEach(r => {
            total += parseFloat(r.netamount || 0);
        });
        setSubtotal(total);
    }, [rows]);
    const fetchPO = () => {
        axios.get(`${baseUrl}purchase-order/${id}/`)
            .then(res => {
                const po = res.data;
                setPoData(po);
                const mapped = (po.items || []).map(item => ({
                    id: item.id,
                    product: item.product,
                    qty: item.ordered_qty || 0,
                    fqty: 0,
                    totqty: item.ordered_qty || 0,
                    pprice: item.rate || 0,
                    mrp: item.mrp || 0,
                    disc: 0,
                    sgst: (item.gst || 0) / 2,
                    cgst: (item.gst || 0) / 2,
                    netamount: item.net_amount || 0,
                    gstamount: 0,
                    batch: "",
                    exp_mn: "",
                    exp_yr: ""
                }));
                setRows(mapped);
            })
            .catch(() => {
                Swal.fire("Error", "Failed to load PO", "error");
            });
    };
    const handleAddRow = () => {
        setRows(prev => ([
            ...prev,
            {
                id: "",
                product: "",
                qty: 0,
                fqty: 0,
                totqty: 0,
                pprice: 0,
                mrp: 0,
                disc: 0,
                sgst: 0,
                cgst: 0,
                netamount: 0,
                gstamount: 0,
            }
        ]));
    };
    const handleDeleteRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    };
    const handleChange = (e, index) => {
        const {name, value} = e.target;
        const newRows = [...rows];
        newRows[index][name] = value;
        const qty = parseFloat(newRows[index].qty || 0);
        const rate = parseFloat(newRows[index].pprice || 0);
        const disc = parseFloat(newRows[index].disc || 0);
        const sgst = parseFloat(newRows[index].sgst || 0);
        const cgst = parseFloat(newRows[index].cgst || 0);
        const gross = qty * rate;
        const discount = (gross * disc) / 100;
        const taxable = gross - discount;
        const gst = taxable * ((sgst + cgst) / 100);
        newRows[index].totqty = qty;
        newRows[index].gstamount = gst;
        newRows[index].netamount = taxable + gst;
        setRows(newRows);
    };
    const submitGRN = async () => {
        if (!poData.id) {
            Swal.fire("Error", "PO not loaded", "error");
            return;
        }
        if (rows.length === 0) {
            Swal.fire("Error", "No items", "error");
            return;
        }
        setIsSubmitting(true);
        try {
            const total = rows.reduce(
                (a, b) => a + parseFloat(b.netamount || 0),
                0
            );
            const payload = new FormData();
            payload.append("po_id", poData.id);
            payload.append("grn_date", selectedDate.toISOString().slice(0, 10));
            payload.append("invoice", invoiceNo);
            payload.append("total_amount", total);
            payload.append("item_id", rows.map(r => r.id).join(","));
            payload.append("product", rows.map(r => r.product).join(","));
            payload.append("qty", rows.map(r => r.qty).join(","));
            payload.append("rate", rows.map(r => r.pprice).join(","));
            payload.append("sgst", rows.map(r => r.sgst).join(","));
            payload.append("cgst", rows.map(r => r.cgst).join(","));
            payload.append("net_amount", rows.map(r => r.netamount).join(","));
            payload.append("addedby", userName);
            payload.append("location", userLocation);
            payload.append("ip_add", ipAddress);
            await axios.post(`${baseUrl}po-to-grn-create/`, payload);
            Swal.fire("Success", "GRN Created", "success");
            setTimeout(() => {
                window.location.href = "/grn-list/";
            }, 1200);
        } catch (err) {
            console.log(err);
            Swal.fire("Error", "Failed to create GRN", "error");
        }
        setIsSubmitting(false);
    };
    return (
        <section className="container mt-4">

            <h3 className="text-center">PO → GRN Entry</h3>

            {/* HEADER */}
            <div className="row mt-3">
                <div className="col-md-4">
                    <label>PO No</label>
                    <input className="form-control" value={poData.po_no || ""} readOnly/>
                </div>

                <div className="col-md-4">
                    <label>Vendor</label>
                    <input className="form-control" value={poData.vendor?.name || ""} readOnly/>
                </div>

                <div className="col-md-4">
                    <label>GRN Date</label>
                    <DatePicker
                        selected={selectedDate}
                        onChange={setSelectedDate}
                        className="form-control"
                        dateFormat="yyyy-MM-dd"
                    />
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-md-4">
                    <label>Invoice No</label>
                    <input
                        className="form-control"
                        value={invoiceNo}
                        onChange={(e) => setInvoiceNo(e.target.value)}
                    />
                </div>

                <div className="col-md-4">
                    <label>GRN Total</label>
                    <input className="form-control" value={subtotal.toFixed(2)} readOnly/>
                </div>
            </div>

            {/* TABLE */}
            <div className="table-responsive mt-4">
                <table className="erp-table-modern">

                    <thead style={{backgroundColor: "#1bc5ce", color: "white"}}>
                    <tr>
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Rate</th>
                        <th>Disc %</th>
                        <th>SGST</th>
                        <th>CGST</th>
                        <th>Net Amount</th>
                        <th>Action</th>
                    </tr>
                    </thead>

                    <tbody>
                    {rows.map((row, index) => (
                        <tr key={index}>

                            <td>{row.product}</td>

                            <td>
                                <input name="qty" className="form-control"
                                       value={row.qty}
                                       onChange={(e) => handleChange(e, index)}
                                />
                            </td>

                            <td>
                                <input name="pprice" className="form-control"
                                       value={row.pprice}
                                       onChange={(e) => handleChange(e, index)}
                                />
                            </td>

                            <td>
                                <input name="disc" className="form-control"
                                       value={row.disc}
                                       onChange={(e) => handleChange(e, index)}
                                />
                            </td>

                            <td>{row.sgst}</td>
                            <td>{row.cgst}</td>

                            <td>{parseFloat(row.netamount || 0).toFixed(2)}</td>

                            <td>
                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleDeleteRow(index)}
                                >
                                    X
                                </button>
                            </td>

                        </tr>
                    ))}
                    </tbody>

                </table>

                <button
                    className="btn btn-success mt-3"
                    onClick={handleAddRow}
                >
                    Add More
                </button>
            </div>

            {/* SUBMIT */}
            <div className="text-center mt-4">
                <button
                    className="btn btn-primary"
                    onClick={submitGRN}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? "Creating..." : "Create GRN"}
                </button>
            </div>

        </section>
    );
};
export default PoToGrnEntry;